<template>
  <p class="mb-1 smaller">
    {{ label }}
    <span v-if="!noValue"> : </span>
    <span :class="{'text-muted': value === null }" v-if="!noValue">
      {{ value | notSpecified }}
    </span>
  </p>
</template>

<script>
export default {
  name: 'SpecifiedField',
  props: {
    label: String,
    value: {
      default: null
    },
    noValue: {
      default: false
    }
  }
}
</script>
